import type { CategoryChain } from '@@partner:types:app'
import type { GQL_ID } from '@@partner:types:graphql'

import { gql, useQuery } from '@apollo/client'

export interface FetchProductDetails {
  categoriesChainsFromIds: CategoryChain[]
}

export interface FetchProductDetailsVariables {
  categoryIds?: GQL_ID[]
}

export const GQL_QUERY_FETCH_CATEGORY_CHAINS = gql`
  query ($categoryIds: [ID]!) {
    categoriesChainsFromIds(category_ids: $categoryIds) {
      id
      namesChain
      pathsChain
    }
  }
`

export const useFetchCategoriesChainsFromIds = (categoryIds?: GQL_ID[]) => {
  return useQuery<FetchProductDetails, FetchProductDetailsVariables>(
    GQL_QUERY_FETCH_CATEGORY_CHAINS,
    {
      variables: {
        categoryIds
      },
      skip: !categoryIds
    }
  )
}
